/* Elvoni storefront — AJAX cart (add / update / remove). Progressive enhancement. */
(function () {
  'use strict';
  var S = (window.EV_STRINGS || {});

  // Keyboard support for the mobile nav drawer (Enter/Space toggle, Esc to close)
  document.addEventListener('keydown', function (e) {
    var cb = document.getElementById('ev-nav-toggle');
    if (!cb) { return; }
    if (e.key === 'Escape' && cb.checked) { cb.checked = false; return; }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.ev-burger, .ev-close')) {
      e.preventDefault();
      cb.checked = !cb.checked;
    }
  });

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function setHeaderCount(count) {
    var cart = document.querySelector('.ev-cart');
    if (!cart) return;
    var badge = cart.querySelector('.ev-count');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ev-count';
        cart.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.parentNode.removeChild(badge);
    }
  }

  var toastTimer;
  function toast(msg) {
    var t = document.querySelector('.ev-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'ev-toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function () { t.classList.add('show'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---- Cart drawer -------------------------------------------------------
     Adding to the bag used to show a toast and leave the shopper where she
     was. Now the bag slides out with the item, the real total and a Checkout
     button. The contents are re-rendered by Liquid via ?section_id so prices,
     discounts and translations are never rebuilt in JavaScript.
  ------------------------------------------------------------------------ */
  var ROOT = (S.root && S.root !== '/') ? S.root : '';
  var lastFocus = null;

  function drawer() { return document.querySelector('[data-ev-cartdrawer]'); }

  function openDrawer() {
    var d = drawer();
    if (!d) return false;
    lastFocus = document.activeElement;
    d.hidden = false;

    // The closed state needs one paint before the class lands or the panel
    // jumps instead of sliding. requestAnimationFrame does that — but it is
    // throttled to nothing in a background tab, which would leave the bag
    // un-hidden and never revealed, so a timer backs it up. Both paths are
    // idempotent.
    var revealed = false;
    function reveal() {
      if (revealed) return;
      revealed = true;
      d.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      var panel = d.querySelector('.ev-cdr-panel');
      if (panel) panel.focus();
    }
    requestAnimationFrame(reveal);
    setTimeout(reveal, 60);
    return true;
  }

  function closeDrawer() {
    var d = drawer();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var done = function () { d.hidden = true; };
    var panel = d.querySelector('.ev-cdr-panel');
    if (panel) panel.addEventListener('transitionend', done, { once: true });
    else done();
    setTimeout(done, 400); // belt and braces if the transition never fires
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refreshDrawer() {
    return fetch(ROOT + '/?section_id=ev-cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ev-cd-body]');
        var cur = document.querySelector('[data-ev-cartdrawer] [data-ev-cd-body]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-ev-cd-close]')) { e.preventDefault(); closeDrawer(); return; }
    // the header bag opens the drawer; its href stays a working no-JS fallback
    var bag = e.target.closest('.ev-cart');
    if (bag && drawer()) {
      e.preventDefault();
      refreshDrawer().then(openDrawer).catch(function () { window.location.href = bag.href; });
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (e.key === 'Escape' && d && !d.hidden) closeDrawer();
  });

  // Coming back from checkout restores the page from the back/forward cache
  // with the drawer still open and the scroll still locked.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { document.documentElement.style.overflow = ''; var d = drawer(); if (d) { d.hidden = true; d.classList.remove('is-open'); } }
  });

  window.EV_CART = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer };

  /* ---- Add to cart: quick-add cards + product page form ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList) return;
    if (!form.classList.contains('ev-quick-form') && !form.classList.contains('ev-pform')) return;
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"], button:not([type])');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = (S.adding || 'Adding…'); }

    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) { return r.json().then(function (j) { throw j; }); } return r.json(); })
      .then(function () { return getCart(); })
      .then(function (cart) {
        setHeaderCount(cart.item_count);
        // Show the bag. If the drawer is missing for any reason, fall back to
        // the old toast rather than leaving the shopper with no feedback.
        return refreshDrawer()
          .then(function () { if (!openDrawer()) toast(S.added || 'Added to your bag'); })
          .catch(function () { toast(S.added || 'Added to your bag'); });
      })
      .catch(function (err) { toast(err && err.description ? err.description : (S.add_error || 'Sorry, that could not be added.')); })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
  });

  /* ---- Cart page: live quantity change + remove (no full reload) ---- */
  function rerenderCart() {
    return fetch('/cart', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.ev-page .ev-wrap');
        var cur = document.querySelector('.ev-page .ev-wrap');
        if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
      });
  }

  function changeLine(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setHeaderCount(cart.item_count); return rerenderCart(); })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp.matches || !inp.matches('.ev-cart-item input[name="updates[]"]')) return;
    var item = inp.closest('.ev-cart-item');
    if (!item || !item.dataset.line) return;
    inp.disabled = true;
    changeLine(parseInt(item.dataset.line, 10), Math.max(0, parseInt(inp.value || '0', 10)));
  });

  // Enter in the quantity box must NOT submit the form (that would trigger Checkout)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('.ev-cart-item input[name="updates[]"]')) {
      e.preventDefault();
      e.target.blur();
    }
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest ? e.target.closest('.ev-remove') : null;
    if (!rm) return;
    var item = rm.closest('.ev-cart-item');
    if (!item || !item.dataset.line) return; // let the href work as a no-JS fallback
    e.preventDefault();
    changeLine(parseInt(item.dataset.line, 10), 0);
  });

  // Quantity stepper (− / +)
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.ev-qty-btn') : null;
    if (!b) return;
    e.preventDefault();
    var wrap = b.closest('.ev-qty-stepper');
    var inp = wrap ? wrap.querySelector('input[name="updates[]"], input[name="quantity"]') : null;
    if (!inp) return;
    var step = parseInt(b.getAttribute('data-step'), 10) || 0;
    var val = Math.max(1, (parseInt(inp.value, 10) || 1) + step);
    if (String(val) === String(inp.value)) return;
    inp.value = val;
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Blank search → go to the shop page
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('ev-search-form')) return;
    var q = form.querySelector('input[name="q"]');
    if (q && !q.value.trim()) {
      e.preventDefault();
      window.location.href = '/collections';
    }
  });

  /* ---- Product gallery: fade between images, arrows, thumbs, swipe, keys ---- */
  function initGalleries() {
    var rtl = document.documentElement.getAttribute('dir') === 'rtl';
    var galleries = document.querySelectorAll('[data-ev-gallery]');
    for (var gi = 0; gi < galleries.length; gi++) {
      (function (g) {
        if (g.dataset.evReady) return;
        g.dataset.evReady = '1';
        var slides = [].slice.call(g.querySelectorAll('[data-ev-slide]'));
        if (slides.length < 2) return;
        var thumbs = [].slice.call(g.querySelectorAll('[data-ev-goto]'));
        var stage = g.querySelector('[data-ev-stage]');
        var prev = g.querySelector('[data-ev-prev]');
        var next = g.querySelector('[data-ev-next]');
        var i = 0;

        function show(n) {
          n = (n % slides.length + slides.length) % slides.length;
          if (n === i) return;
          slides[i].classList.remove('is-active');
          slides[i].setAttribute('aria-hidden', 'true');
          slides[n].classList.add('is-active');
          slides[n].removeAttribute('aria-hidden');
          if (thumbs[i]) thumbs[i].classList.remove('is-active');
          if (thumbs[n]) thumbs[n].classList.add('is-active');
          i = n;
        }

        if (prev) prev.addEventListener('click', function () { show(i - 1); });
        if (next) next.addEventListener('click', function () { show(i + 1); });
        for (var t = 0; t < thumbs.length; t++) {
          (function (idx) { thumbs[idx].addEventListener('click', function () { show(idx); }); })(t);
        }

        g.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { show(rtl ? i + 1 : i - 1); }
          else if (e.key === 'ArrowRight') { show(rtl ? i - 1 : i + 1); }
        });

        var x0 = null, y0 = null;
        stage.addEventListener('touchstart', function (e) {
          x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
        }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          var dy = e.changedTouches[0].clientY - y0;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            var fwd = rtl ? dx > 0 : dx < 0;
            show(fwd ? i + 1 : i - 1);
          }
          x0 = null; y0 = null;
        }, { passive: true });
      })(galleries[gi]);
    }
  }
  if (document.readyState !== 'loading') initGalleries();
  else document.addEventListener('DOMContentLoaded', initGalleries);
})();


/* ---------------------------------------------------------------------------
   Second photograph, fetched on demand.

   Every card carries a second photograph. Downloading it up front meant a
   collection page pulled 39 pictures to show 24 products, so it is now
   fetched only when someone actually reaches for the card.

   IMPORTANT — do NOT put a (hover:hover) guard back on this. A phone has no
   real hover, but a soft touch still triggers :hover in CSS, so gating on
   hover capability made the card fade to an empty picture and go blank
   beige on tap. Touch must hydrate too. The CSS will not begin the
   crossfade until this code adds .is-alt-ready, so the original photograph
   simply stays put until the second one is genuinely decoded.
--------------------------------------------------------------------------- */
(function () {
  function hydrate(card) {
    var img = card.querySelector('.ev-card-img-alt[data-srcset]');
    if (!img) return;
    var ph = img.parentNode;
    var ss = img.getAttribute('data-srcset'), s = img.getAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    // Only once the picture is really here does the crossfade become legal.
    // No img.decode() here on purpose — it can reject while the source is
    // still being swapped, which left the flag unset and the fade stuck.
    // On an error we deliberately do nothing: the original photograph stays.
    function ready() { if (ph && ph.classList) ph.classList.add('is-alt-ready'); }
    img.addEventListener('load', ready, { once: true });
    if (ss) img.setAttribute('srcset', ss);
    if (s) img.setAttribute('src', s);
    if (img.complete && img.naturalWidth > 1) ready();   // already in cache
  }

  function from(e) {
    var t = e.target;
    return t && t.closest ? t.closest('.ev-card') : null;
  }

  // touchstart fires fractionally before the browser fakes :hover on a tap,
  // which buys the picture a head start on a phone.
  document.addEventListener('touchstart', function (e) {
    var c = from(e); if (c) hydrate(c);
  }, { passive: true });

  document.addEventListener('pointerover', function (e) {
    var c = from(e); if (c) hydrate(c);
  }, { passive: true });

  // Keyboard users never send a pointer event.
  document.addEventListener('focusin', function (e) {
    var c = from(e); if (c) hydrate(c);
  });
})();


/* ---------------------------------------------------------------------------
   Full-screen photograph viewer.

   Two things were stopping a shopper looking closely at a garment:
   the gallery crops every picture to 3/4 with object-fit:cover, and the stage
   carried touch-action:pan-y, which tells the browser not to handle pinch.
   The CSS now names pinch-zoom; this adds the deliberate way in.

   Tap/click the photograph  -> whole uncropped picture, full screen
   Tap/click it again        -> magnified, drag to move around
   Esc / ✕ / backdrop        -> close
   Arrows                    -> move between photographs

   The 2048px file is only requested when the viewer is actually opened, so
   nothing extra is downloaded by a shopper who never zooms.
--------------------------------------------------------------------------- */
(function () {
  var gallery = document.querySelector('[data-ev-gallery]');
  if (!gallery) return;
  var stage = gallery.querySelector('[data-ev-stage]');
  if (!stage) return;

  var slides = [].slice.call(gallery.querySelectorAll('.ev-gslide'));
  var sources = slides.map(function (s) { return s.getAttribute('data-ev-zoom'); }).filter(Boolean);
  if (!sources.length) return;

  var isAr = document.documentElement.lang === 'ar';
  var T = isAr
    ? { close: 'إغلاق', prev: 'الصورة السابقة', next: 'الصورة التالية', hint: 'انقري للتكبير' }
    : { close: 'Close',  prev: 'Previous image', next: 'Next image',   hint: 'Tap to magnify' };

  var box, pane, img, idx = 0, mag = false, lastFocus = null;

  function svg(d) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' + d + '</svg>';
  }

  function build() {
    box = document.createElement('div');
    box.className = 'ev-zoom';
    box.setAttribute('hidden', '');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML =
      '<div class="ev-zoom-pane" data-pane><img alt=""></div>' +
      '<button type="button" class="ev-zoom-btn ev-zoom-x" data-close aria-label="' + T.close + '">' +
        svg('<path d="M6 6l12 12M18 6L6 18"/>') + '</button>' +
      (sources.length > 1
        ? '<button type="button" class="ev-zoom-btn ev-zoom-prev" data-prev aria-label="' + T.prev + '">' +
            svg('<polyline points="15 18 9 12 15 6"/>') + '</button>' +
          '<button type="button" class="ev-zoom-btn ev-zoom-next" data-next aria-label="' + T.next + '">' +
            svg('<polyline points="9 18 15 12 9 6"/>') + '</button>'
        : '') +
      '<p class="ev-zoom-hint">' + T.hint + '</p>';
    document.body.appendChild(box);
    pane = box.querySelector('[data-pane]');
    img = box.querySelector('img');

    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) return close();
      if (e.target.closest('[data-prev]')) return go(idx - 1);
      if (e.target.closest('[data-next]')) return go(idx + 1);
      if (e.target === pane || e.target === box) return close();   // backdrop
    });
    img.addEventListener('click', function () { setMag(!mag); });
    document.addEventListener('keydown', function (e) {
      if (box.hasAttribute('hidden')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(isAr ? idx + 1 : idx - 1);
      else if (e.key === 'ArrowRight') go(isAr ? idx - 1 : idx + 1);
    });
    addDragToPan();
  }

  function setMag(on) {
    mag = on;
    box.classList.toggle('is-mag', on);
    if (on) {
      // Never derive a width of 0: if the pane cannot be measured for any
      // reason, setting width:0 would blank the photograph entirely. Fall back
      // to the viewport, then to the image's own size.
      var base = pane.clientWidth || window.innerWidth || img.naturalWidth || 0;
      if (base > 0) img.style.width = (base * 2.2) + 'px';
      // centre on the middle of what was visible
      pane.scrollLeft = (pane.scrollWidth - pane.clientWidth) / 2;
      pane.scrollTop = (pane.scrollHeight - pane.clientHeight) / 2;
    } else {
      img.style.width = '';
      pane.scrollTo(0, 0);
    }
  }

  function addDragToPan() {
    var down = false, sx = 0, sy = 0, sl = 0, st = 0;
    img.addEventListener('pointerdown', function (e) {
      if (!mag) return;
      down = true; sx = e.clientX; sy = e.clientY;
      sl = pane.scrollLeft; st = pane.scrollTop;
      img.classList.add('is-dragging');
      try { img.setPointerCapture(e.pointerId); } catch (err) {}
    });
    img.addEventListener('pointermove', function (e) {
      if (!down) return;
      pane.scrollLeft = sl - (e.clientX - sx);
      pane.scrollTop = st - (e.clientY - sy);
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      img.addEventListener(ev, function () { down = false; img.classList.remove('is-dragging'); });
    });
  }

  function go(n) {
    if (!sources.length) return;
    idx = (n + sources.length) % sources.length;
    setMag(false);
    img.src = sources[idx];
    var live = slides[idx] && slides[idx].querySelector('img');
    img.alt = live ? live.alt : '';
  }

  function open(n) {
    if (!box) build();
    lastFocus = document.activeElement;
    box.removeAttribute('hidden');
    go(n);
    // Force a reflow, then reveal. requestAnimationFrame would be tidier but it
    // does not fire in a background tab, which would leave the viewer open and
    // fully transparent — present, blocking, and invisible.
    void box.offsetHeight;
    box.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var x = box.querySelector('[data-close]'); if (x) x.focus();
  }

  function close() {
    if (!box) return;
    setMag(false);
    box.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var done = function () { box.setAttribute('hidden', ''); };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
    else setTimeout(done, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Opening: click the photograph, but never let a swipe between images count
  // as a click — the gallery's own swipe handler owns horizontal movement.
  var px = null, py = null;
  stage.addEventListener('pointerdown', function (e) { px = e.clientX; py = e.clientY; });
  stage.addEventListener('click', function (e) {
    if (e.target.closest('.ev-gnav')) return;              // arrows keep their job
    if (px !== null && (Math.abs(e.clientX - px) > 10 || Math.abs(e.clientY - py) > 10)) return;
    var active = gallery.querySelector('.ev-gslide.is-active');
    var n = active ? slides.indexOf(active) : 0;
    open(n < 0 ? 0 : n);
  });
  stage.setAttribute('role', 'button');
  stage.setAttribute('tabindex', '0');
  stage.setAttribute('aria-label', T.hint);
  stage.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      var active = gallery.querySelector('.ev-gslide.is-active');
      var n = active ? slides.indexOf(active) : 0;
      open(n < 0 ? 0 : n);
    }
  });
})();
/* zoom viewer v1 */
